
import config from '../constants/config';
import { stringLitArray } from '../utils/utilsT';
import { AddressDetailsT } from './AddressDetailsT'
import { JobTypeTStrings } from './Job';
import { PackingMaterialsLineItemT } from './PackingMaterialsT';


export const ListOptionsEstimate =
    [
        'changeCrewSizeFee',
        'changeDatetimeFee',
        'deposit',
        'discount',
        'estimate',
        'heavyItemFee',
        'longCarryRate',
        'longDistanceFee',
        'materials',
        'moving',
        'hourlyRateOne',
        'hourlyRateTwo',
        'hourlyRateThree',
        'hourlyRateFour',
        'hourlyRateOnePacking',
        'hourlyRateTwoPacking',
        'hourlyRateThreePacking',
        'hourlyRateFourPacking',
        'serviceFee',
        'tip',
        'truckByDistance',
        'truckByTime',
        'truckFlatRate',
    ]

export const OptionsWorkerPay = {
    laborVariable: "Labor Variable",
    laborFlat: "Labor Flat",
}
export enum WorkerPayT {
    laborVariable = 'laborVariable',
    laborFlat = 'laborFlat',
}

export type WorkerTypeTStrings = keyof typeof WorkerPayT;


export const DefaulVariablesByJobType = {
    all: "truckByDistance",
    moving_labor: "hourlyRateTwo",
    interstate: "moving",

}

export interface VariableT {
    value: number
    rateLabel?: string
    unitsLabel: string
    verboseName: string
}


export enum ListOfVariables {
    estimate = 'estimate',
    depositLocal = 'depositLocal',
    depositLong = 'depositLong',
    beforePickupLocal = 'beforePickupLocal',
    beforePickupLong = 'beforePickupLong',
    beforeDeliveryLocal = 'beforeDeliveryLocal',
    beforeDeliveryLong = 'beforeDeliveryLong',
    afterDeliveryLocal = 'afterDeliveryLocal',
    afterDeliveryLong = 'afterDeliveryLong',
    minimumTime = 'minimumTime',
    truckByDistance = 'truckByDistance',
    truckFlatRate = 'truckFlatRate',
    hourlyRateOne = 'hourlyRateOne',
    hourlyRateTwo = 'hourlyRateTwo',
    hourlyRateThree = 'hourlyRateThree',
    hourlyRateFour = 'hourlyRateFour',
    hourlyRateOnePacking = 'hourlyRateOnePacking',
    hourlyRateTwoPacking = 'hourlyRateTwoPacking',
    hourlyRateThreePacking = 'hourlyRateThreePacking',
    moving = 'moving',
    hourlyRateFourPacking = 'hourlyRateFourPacking',
    movingVolToWeightConversion = 'movingVolToWeightConversion',
    longCarryUnitDistance = 'longCarryUnitDistance',
    longCarryRate = 'longCarryRate',
    workerPay = 'workerPay',
    workerFlatPay = 'workerFlatPay',
    serviceFee = 'serviceFee',
    discount = 'discount',
    deposit = 'deposit',
    localIntrastateMargin = "localIntrastateMargin",
    longDistanceFee = "longDistanceFee",
    heavyItemFee = "heavyItemFee",
    changeCrewSizeFee = "changeCrewSizeFee",
    changeDatetimeFee = "changeDatetimeFee",
    tip = "tip",
    bookingFee = "bookingFee",
    truckByTime = "truckByTime",
    materials = 'materials'
}

export type ListOfVariablesStrings = keyof typeof ListOfVariables;
/**
 * can use one item
 */
// export type VariablesTypes = {
//     [key in ListOfVariables]?: VariableT
// }

export type VariablesT = {
    [key in ListOfVariables]: VariableT; // Note that "key in".
    //  [key in ListOfVariables]?: VariableT
}

export const VariablesObj: VariablesT = {
    "estimate": {
        "value": 0,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Estimate"
    },
    "depositLocal": {
        "value": 0,
        "rateLabel": "$",
        "unitsLabel": "$",
        "verboseName": "Deposit Local"
    },
    "depositLong": {
        "value": 0,
        "rateLabel": "$",
        "unitsLabel": "$",
        "verboseName": "Deposit Long"
    },
    "beforePickupLocal": {
        "value": 0,
        "rateLabel": "%",
        "unitsLabel": "%",
        "verboseName": "Before Pick-up Local, %"
    },
    "beforePickupLong": {
        "value": 0,
        "rateLabel": "%",
        "unitsLabel": "%",
        "verboseName": "Before Pick-up Long, %"
    },
    "beforeDeliveryLocal": {
        "value": 0,
        "rateLabel": "%",
        "unitsLabel": "%",
        "verboseName": "Before Delivery Local, %"
    },
    "beforeDeliveryLong": {
        "value": 0,
        "rateLabel": "%",
        "unitsLabel": "%",
        "verboseName": "Before Delivery Long, %"
    },
    "afterDeliveryLocal": {
        "value": 100,
        "rateLabel": "%",
        "unitsLabel": "%",
        "verboseName": "After Delivery Local, %"
    },
    "afterDeliveryLong": {
        "value": 100,
        "rateLabel": "%",
        "unitsLabel": "%",
        "verboseName": "After Delivery Long, %"
    },
    "minimumTime": {
        "value": 3,
        "rateLabel": "hour",
        "unitsLabel": "hours",
        "verboseName": "Minimum Time"
    },
    "truckByDistance": {
        "value": 1,
        "rateLabel": "$/mile",
        "unitsLabel": "miles",
        "verboseName": "Truck, By Distance"
    },
    "truckFlatRate": {
        "value": 80,
        "rateLabel": "$",
        "unitsLabel": "",
        "verboseName": "Truck, Flat Rate"
    },
    "hourlyRateOne": {
        "value": 40,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Moving labor, Crew of 1"
    },
    "hourlyRateTwo": {
        "value": 80,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Moving labor, Crew of 2"
    },
    "hourlyRateThree": {
        "value": 120,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Moving labor, Crew of 3"
    },
    "hourlyRateFour": {
        "value": 160,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Moving labor, Crew of 4"
    },
    "hourlyRateOnePacking": {
        "value": 30,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Packing labor, Crew of 1"
    },
    "hourlyRateTwoPacking": {
        "value": 60,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Packing labor, Crew of 2"
    },
    "hourlyRateThreePacking": {
        "value": 90,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Packing labor, Crew of 3"
    },
    "hourlyRateFourPacking": {
        "value": 120,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Packing labor, Crew of 4"
    },
    "moving": {
        "value": 1.5,
        "rateLabel": "$/lbs",
        "unitsLabel": "lbs",
        "verboseName": "Moving"
    },
    "movingVolToWeightConversion": {
        "value": 7,
        "unitsLabel": "lbs",
        "verboseName": "Volume to Weight Converstion"
    },
    "longCarryUnitDistance": {
        "value": 100,
        "unitsLabel": "ft",
        "verboseName": "Long Carry Unit Distance"
    },
    "longCarryRate": {
        "value": 50,
        "rateLabel": "$/<longCarryUnitDistance>ft",
        "unitsLabel": "<longCarryUnitDistance>ft",
        "verboseName": "Long Carry Rate"
    },
    'workerPay': {
        "value": 12,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Worker Pay - Default, $"
    },
    'workerFlatPay': {
        "value": 150,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Worker Flat Pay - Default, $"
    },
    'serviceFee': {
        "value": 40,
        "rateLabel": "$",
        "unitsLabel": "",
        "verboseName": "Service Fee"
    },
    'discount': {
        "value": 40,
        "rateLabel": "$",
        "unitsLabel": "",
        "verboseName": "Discount"
    },
    'deposit': {
        "value": 50,
        "rateLabel": "$",
        "unitsLabel": "",
        "verboseName": "Deposit"
    },
    'localIntrastateMargin': {
        "value": 30,
        "rateLabel": "$/mile",
        "unitsLabel": "miles",
        "verboseName": "Local Intrastate Margin"
    },
    'longDistanceFee': {
        "value": 1,
        "rateLabel": "fee",
        "unitsLabel": "",
        "verboseName": "Long-distance Fee"
    },
    'heavyItemFee': {
        "value": 1,
        "rateLabel": "fee",
        "unitsLabel": "",
        "verboseName": "Heavy Item Fee"
    },
    'changeCrewSizeFee': {
        "value": 1,
        "rateLabel": "$",
        "unitsLabel": "",
        "verboseName": "Change Crew Size Fee"
    },
    'changeDatetimeFee': {
        "value": 1,
        "rateLabel": "$",
        "unitsLabel": "",
        "verboseName": "Change Datetime Fee"
    },
    'tip': {
        "value": 1,
        "rateLabel": "$",
        "unitsLabel": "",
        "verboseName": "Tip"
    },
    "bookingFee": {
        "value": config.defaultBookingFee,
        "rateLabel": "$",
        "unitsLabel": "",
        "verboseName": "Booking Fee"
    },
    "truckByTime": {
        "value": 1,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Truck, By Time"
    },
    'materials': {
        "value": 1,
        "rateLabel": "$",
        "unitsLabel": "",
        "verboseName": "Materials"
    },

}

// Add Service Fee, Discount, and Deposit to Job->Financial Item options

export const SMTPSecureT = stringLitArray(['', 'ssl', 'tls']);
export type SMTPSecureTStrings = (typeof SMTPSecureT)[number];
export interface MailServerT {
    host: string
    username: string
    password?: string
    port: number
    auth: boolean
    secure: SMTPSecureTStrings
}



export interface CompanyT {
    id: number
    address: string
    addressTwo?: string
    addressState: string
    addressDetails: AddressDetailsT
    email: string
    phone: string
    name: string
    description?: string
    logo: string
    variables: VariablesT
    stateMeta?: any
    unit: string
    standardCrewSize: number
    smuvsPhone?: number
    defaultJobType?: JobTypeTStrings | null
    voicemail?: string
    recordingMaxLength?: number
    mailServer?: MailServerT
    workers?: Array<number>
    salesCall?: Array<number>
    defaultWorkerPay?: WorkerTypeTStrings | null
    showDocuments?: boolean
    handle?: string
    packingMaterials?: Array<PackingMaterialsLineItemT>
    isPremium?: boolean
    customDocuments?: any
}


export const companyObj: CompanyT = {
    id: -1,
    address: "",
    addressState: "",
    addressDetails: {
        "address": "",
        "latitude": "",
        "longitude": "",
        "country": "",
        "state": "",
        "city": "",
        "address_line_one": "",
        "address_line_two": "",
        "zipcode": "",
    },
    customDocuments: null,
    email: "",
    isPremium: false,
    name: "",
    logo: "",
    phone: "",
    variables: VariablesObj,
    unit: "",
    standardCrewSize: 0,
    voicemail: "",
    defaultWorkerPay: "laborVariable",
}